/**
 * @generated SignedSource<<0f0ea36ac2b0bf13cf09acbeccc8082b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccessModelSettingsRefetchQuery$variables = Record<PropertyKey, never>;
export type AccessModelSettingsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccessModelSettings_awsAccessRoles">;
};
export type AccessModelSettingsRefetchQuery = {
  response: AccessModelSettingsRefetchQuery$data;
  variables: AccessModelSettingsRefetchQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccessModelSettingsRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccessModelSettings_awsAccessRoles"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccessModelSettingsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AWSAccessRoles",
        "kind": "LinkedField",
        "name": "awsAccessRoles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountDiscoveryRoleARN",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryRoleARN",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readOnlyRoleARN",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remediationPolicyRoleARN",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "samplePrimaryTrust",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "808d07c0070f12afa97caab7d66a0f9a",
    "id": null,
    "metadata": {},
    "name": "AccessModelSettingsRefetchQuery",
    "operationKind": "query",
    "text": "query AccessModelSettingsRefetchQuery {\n  ...AccessModelSettings_awsAccessRoles\n}\n\nfragment AccessModelSettings_awsAccessRoles on Query {\n  ...GatewayRolesForm_awsAccessRoles\n  awsAccessRoles {\n    externalID\n    primaryRoleARN\n    samplePrimaryTrust\n  }\n}\n\nfragment GatewayRolesForm_awsAccessRoles on Query {\n  awsAccessRoles {\n    accountDiscoveryRoleARN\n    primaryRoleARN\n    readOnlyRoleARN\n    remediationPolicyRoleARN\n    samplePrimaryTrust\n  }\n}\n"
  }
};

(node as any).hash = "93ef7e20d65fd88393693c6d4d9d8bde";

export default node;
